import { orderService } from "@/api/orderService"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

export const useCreateOrder = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      orderData,
      orderId,
    }: {
      orderData: any
      orderId?: number
    }) => {
      if (orderId) {
        return orderService.updateOrder(orderId, orderData)
      }
      return orderService.createOrder(orderData)
    },
    onSuccess: (_, variables) => {
      toast.success(
        variables.orderId
          ? "Order updated successfully"
          : "Order created successfully"
      )
      queryClient.invalidateQueries({ queryKey: ["order"] })
    },
    onError: (error: any) => {
      console.log("inside errror", error)
      toast.error(error?.message || "Failed to process order")
    },
  })
}
